import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountSectionCardComponent } from './account-section-card';
import { AccountReviewCardComponent } from './account-review-card';
import { AccountReview } from './accounts-information.models';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-account-reviews-section',
  standalone: true,
  imports: [CommonModule, AccountSectionCardComponent, AccountReviewCardComponent, TranslatePipe],
  template: `
    <app-account-section-card [title]="'accountsInformation.sections.reviews' | translate" iconClass="fa-solid fa-comments">
      <div class="space-y-4 antialiased">
        @for (review of reviews; track review.name + review.timeAgo) {
          <app-account-review-card [review]="review" class="block animate-fadeIn">
          </app-account-review-card>
        } @empty {
          <div
            class="py-10 flex flex-col items-center justify-center border border-dashed border-border-subtle bg-surface-elevated rounded-2xl text-center font-mono px-4"
          >
            <div
              class="w-12 h-12 rounded-2xl bg-surface-hover flex items-center justify-center text-text-muted mb-3 border border-border-subtle shadow-sm"
            >
              <i class="fa-solid fa-comment-slash text-base"></i>
            </div>
            <h4 class="text-xs font-black text-text-primary uppercase tracking-wider mb-1">
              {{ 'accountsInformation.empty.reviewsTitle' | translate }}
            </h4>
            <p
              class="text-[10px] font-medium text-text-muted max-w-xs leading-relaxed normal-case font-sans"
            >
              {{ 'accountsInformation.empty.reviewsDescription' | translate }}
            </p>
          </div>
        }
      </div>
    </app-account-section-card>
  `,
})
export class AccountReviewsSectionComponent {
  @Input() reviews: AccountReview[] = [];
}
